// extracted by mini-css-extract-plugin
export default {"cardContainer":"cardContainer___WutLD","image":"image___HJgHG","subHeading":"subHeading___czh1F","cardContent":"cardContent___NeOs3"};